import styled from 'styled-components';
import { Text } from '@perch-labs/shrike';

export const StyledHeading = styled(Text).attrs({
  tag: 'h1',
  textStyle: 'heading800',
  margin: { bottom: '16px', top: '32px' },
})``;
